<template>
  <div v-if="page_loading">
    <loading :page_loading="page_loading" />
  </div>
  <div v-else>
    <loading :loading="loading" />
    <v-card class="v-card-bottom-30">
      <v-card-title>
        <a @click="toBack('promotion')">{{ use_language.promotion }}</a>
        <v-icon>mdi-chevron-right</v-icon>
        {{ texttitle }}
      </v-card-title>
    </v-card>

    <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title>
        <div class="py-1">
          <v-icon size="20" color="primary">fa-sliders-h</v-icon
          ><span class="my-3 ml-3"
            >{{ texttitle }}
            <span v-if="nowdateCheck" class="fn-14" style="color: red">
              {{ use_language.not_modify_promotion }}
            </span></span
          >
        </div>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="promotion" lazy-validation>
          <!-- ชื่อโปรโมชั่น -->
          <v-row>
            <v-col cols="12" md="3" lg="2" class="pb-3">
              <h3 class="fn-14">{{ use_language.promotion_name }} :</h3>
            </v-col>
            <v-col cols="12" md="5"   lg="4" class="pt-1 pb-2">
              <v-text-field
                :value="promotion.name"
                @change="(value) => (promotion.name = Trim_value(value))"
                :rules="validateRules.promotionNameRules"
                ref="promotionname"
                outlined
                dense
                hide-details
                :disabled="nowdateCheck"
                autocomplete="off"
              ></v-text-field>
              <span
                v-if="validateRules.promotionNameValidateText != null"
                style="color: red"
                >{{ validateRules.promotionNameValidateText }}</span
              >
            </v-col>
          </v-row>
          <!-- ช่องทาง -->
          <v-row>
            <v-col cols="12" md="3" lg="2">
              <h3 class="fn-14">{{ use_language.channel }} :</h3>
            </v-col>
            <v-col cols="12" md="9" lg="10">
              <div  v-for="i in marketpalce.allData" :key="i.id" class="mt-2">
              
                <v-checkbox
                  v-model="i.selectSeller"
                  class="d-inline-flex"
                  color="info"
                  hide-details
                  :disabled="nowdateCheck"
                  :rules="validateRules.channelRules"
                  ref="channelRef"
                  @click="handleSelectCheckboxMarketplace(i, marketpalce.allData.indexOf(i))">
                  <template v-slot:label >
                  <img :src="i.photoLink" style="width: 30px; border-radius:50px !important;" />
                   
                  <span class="ml-2"> {{ i.name }}</span> 
                  </template>
                </v-checkbox>
              </div>
            </v-col>
            <!-- <span v-if="validateRules.channelRulesValidateText != null" class="my-1" style="color: red;">{{ validateRules.channelRulesValidateText  }}</span> -->
          </v-row>
          <!-- เลือกวันเดือนปี -->
          <v-row>
            <v-col cols="12" md="3" lg="2">
              <h3 class="fn-14">{{ use_language.start_date }} :</h3>
            </v-col>
            <v-col cols="12" md="3" lg="2">
              <v-menu
                ref="startDateMenu"
                v-model="startDateMenu"
                :close-on-content-click="true" 
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="formattedStartDate"
                    @change="value => startDatePromotion = value"
                    autocomplete="off"
                    :label="use_language.start"
                    outlined
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    dense
                    hide-details
                    v-on="on"
                    clearable
                    @click:clear="startDatePromotion = null"
                  >
                    <template v-slot:label>
                      <span>{{ use_language.start }}</span>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="startDatePromotion"
                  @input="startDateMenu = false; updateFormattedStartDate()"
                  no-title
                  class="my-0"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" md="3" lg="2">
              <v-menu
                ref="time_pickerStart"
                v-model="time_pickerStart"
                :close-on-content-click="false"
                :nudge-right="40" 
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="timeStart"
                    @change="(value) => (timeStart = value)"
                    autocomplete="off"
                    prepend-inner-icon="mdi-clock"
                    outlined
                    readonly
                    style="width: 250px"
                    v-on="on"
                    hide-details
                    dense
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="time_pickerStart"
                  v-model="timeStart"
                  format="24hr"
                  full-width 
                ></v-time-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3" lg="2" class="pt-1 pb-2">
              <h3 class="fn-14">{{ use_language.end_date }}:</h3>
            </v-col>
            <v-col cols="12" md="3" lg="2" class="pt-1 pb-2">
                <v-menu
                  ref="endDateMenu"
                  v-model="endDateMenu"
                  :close-on-content-click="true" 
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="formattedEndDate"
                       
                      autocomplete="off"
                      :abel="use_language.end"
                      outlined
                      dense 
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      hide-details
                      v-on="on"
                          clearable
                        @click:clear="endDatePromotion = null"
                    >
                      <template v-slot:label>
                        <span>{{ use_language.end }}</span>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="endDatePromotion"
                    @change="updateFormattedEndDate()"
                    no-title
                    class="my-0"
                  ></v-date-picker>
                </v-menu>


              <!-- ---------- -->
            </v-col>
            <v-col cols="6" md="3" lg="2" class="pt-1 pb-2">
              <!-- เวลา -->
              <!-- <v-combobox
              v-model="promotion.selectedHourEnd"
              :items="promotion.hours"
              outlined
              style="min-width: 200px; max-width: 700px;"
              hide-details
              dense
            ></v-combobox> -->
              <v-menu
                ref="time_pickerEnd"
                v-model="time_pickerEnd"
                :close-on-content-click="false"
                :nudge-right="40" 
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="timeEnd"
                    @change="(value) => (timeEnd = value)"
                    autocomplete="off"
                    prepend-inner-icon="mdi-clock"
                    outlined
                    readonly
                    style="width: 250px"
                    v-on="on"
                    hide-details
                    dense
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="time_pickerEnd"
                  v-model="timeEnd"
                  format="24hr"
                  full-width 
                ></v-time-picker>
              </v-menu>
            </v-col>
          </v-row>
          <!-- ประเภทโปรโมชั่น -->
          <v-row>
            <v-col cols="12" md="3" lg="2" class="pt-1 pb-2">
              <h3 class="fn-14">{{ use_language.promotion_type }} :</h3>
            </v-col>
            <v-col cols="12" md="3" lg="2" class="pt-1 pb-2">
              <v-radio-group
                v-model="promotion.promotionType"
                row
                required
                class="mb-2 is-cod-selector"
                dense
                hide-details
                :disabled="nowdateCheck"
              >
                <v-radio :label="use_language.amount_of_money" :value="1">
                  <template v-slot:label> <span>{{ use_language.amount_of_money }}</span> </template>
                </v-radio>
                <v-radio :label="use_language.replenish_total_quantity" :value="2">
                  <template v-slot:label> <span>{{ use_language.replenish_total_quantity }}</span> </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <!-- ยอดเงินและจำนวน -->
          <v-row v-if="promotion.promotionType === 1">
            <v-col cols="12" md="3" lg="2" class="pt-1 pb-2">
              <h3 class="fn-14">{{ use_language.amount_of_money }} :</h3>
            </v-col>
            <v-col cols="12" md="3" lg="2" class="pt-1 pb-2">
              <v-text-field
                :value="promotion.amount"
                @change="(value) => (promotion.amount = Trim_value(value).replaceAll(',', ''))"
                :rules="validateRules.amountRules"
                ref="promotionamout"
                outlined
                :disabled="nowdateCheck"
                danse
                hide-details
                autocomplete="off"
              ></v-text-field>
              <span v-if="validateRules.amountValidateText != null" style="color: red">{{
                validateRules.amountValidateText
              }}</span>
            </v-col>
            <v-col cols="12" md="3" class="pt-3"> {{ use_language.baht }} </v-col>
          </v-row>

          <v-row v-if="promotion.promotionType === 2">
            <v-col cols="12" md="3" lg="2" class="pt-1 pb-3">
              <h3 class="fn-14">{{ use_language.replenish_total_quantity }} :</h3>
            </v-col>
            <v-col cols="12" md="3" lg="2" class="pt-1 pb-2">
              <v-text-field
                :value="promotion.quantity"
                @change="(value) => (promotion.quantity = Trim_value(value).replaceAll(',', ''))"
                :rules="validateRules.quantityRules"
                ref="promotionquantity"
                outlined
                :disabled="nowdateCheck"
                danse
                hide-details
                autocomplete="off"
              ></v-text-field>
              <span
                v-if="validateRules.quantityValidateText != null"
                style="color: red"
                >{{ validateRules.quantityValidateText }}</span
              >
            </v-col>
            <v-col cols="12" md="3" class="pt-3"> {{ use_language.piece_unit }} </v-col>
          </v-row>
          <v-row v-if="promotion.promotionType === 2">
            <v-col cols="12" md="3" lg="2" class="pt-1 pb-2">
              <h3 class="fn-14">{{ use_language.condition_free_item }} :</h3>
            </v-col>
            <v-col cols="12" md="9" lg="10" class="pt-1 pb-2">
              <v-radio-group
                v-model="promotion.isUseMultiplier"
                row
                required
                class="mb-2 is-cod-selector"
                dense
                hide-details
                :disabled="nowdateCheck"
              >
                <v-radio :label="use_language.amount_of_money" :value="false">
                  <template v-slot:label> <span>{{ use_language.free_only_once }}</span> </template>
                </v-radio>
                <v-radio :label="use_language.replenish_total_quantity" :value="true">
                  <template v-slot:label> <span>{{ use_language.free_base_quantity }}</span> </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <!-- สามารถซ้อนทับกับโปรอื่นได้หรือไม่ -->
          <v-row>
            <v-col cols="12" md="3" lg="2">
              <h3 class="fn-14">{{ use_language.can_combine_promotion }} :</h3>
            </v-col>
            <v-col cols="12" md="3" lg="2">
              <v-radio-group
                v-model="promotion.duplicate"
                row
                required
                :disabled="nowdateCheck"
                class="mb-2 is-cod-selector"
                dense
                hide-details
              >
                <v-radio :label="use_language.can" :value="true">
                  <template v-slot:label> <span>{{ use_language.can }}</span> </template>
                </v-radio>
                <v-radio :label="use_language.cannot" :value="false">
                  <template v-slot:label> <span>{{ use_language.cannot }}</span> </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <!-- ลำดับความสำคัญ -->
          <v-row v-if="!promotion.duplicate">
            <v-col cols="12" md="3" lg="2">
              <h3 class="fn-14">{{ use_language.piority }} :</h3>
            </v-col>
            <v-col cols="12" md="3" lg="2">
              <v-text-field
                :value="promotion.priority"
                @change="(value) => (promotion.priority = Trim_value(value))"
                type="number"
                outlined
                ref="promotionpriority"
                :disabled="nowdateCheck"
                dense
                hide-details
                autocomplete="off"
                :placeholder="use_language.please_specify_piority"
              ></v-text-field>
              <span
                v-if="validateRules.priorityValidateText != null"
                style="color: red"
                >{{ validateRules.priorityValidateText }}</span
              >
            </v-col>
          </v-row>
          <!-- สินค้าที่ร่วมรายการ  -->
          <v-row>
            <v-col cols="12" md="3" lg="2">
              <h3 class="fn-14">{{ use_language.participating_product }} :</h3>
            </v-col>
            <v-col cols="12" md="3" lg="3">
              <v-radio-group
                v-model="promotion.joinProgram"
                row
                required
                :disabled="nowdateCheck"
                class="mb-2 is-cod-selector"
                dense
                hide-details
              >
                <v-radio :label="use_language.buy_anything" :value="true">
                  <template v-slot:label> <span>{{ use_language.buy_anything }}</span> </template>
                </v-radio>
                <v-radio :label="use_language.limit_item" :value="false">
                  <template v-slot:label> <span>{{ use_language.limit_item }}</span> </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="!promotion.joinProgram">
            <v-col class="pb-0" align="left">
              <v-btn
                color="primary"
                class="mr-1"
                :disabled="nowdateCheck"
                outlined
                @click="handleOpenDialogJoinPromotion(limits, 0, 1)"
              >
                <v-icon center>mdi-plus</v-icon>
                {{ use_language.select_product }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0">
              <v-data-table
                :headers="[
                  {
                    text: '#',
                    value: 'index',
                    align: 'center',
                    sortable: false,
                    width: 10,
                  },
                  {
                    text: use_language.picture,
                    value: 'photoLink',
                    align: 'center',
                    sortable: false,
                    width: '50px',
                  },
                  {
                    text: 'SKU',
                    value: 'sku',
                    align: 'center',
                    sortable: false,
                    width: '80px',
                  },
                  {
                    text: use_language.name_product,
                    value: 'name',
                    align: 'left',
                    sortable: false,
                    width: '400px',
                  },
                  {
                    text: use_language.quantity,
                    value: 'quantityInput',
                    align: 'center',
                    sortable: false,
                    width: '120px',
                  },
                  {
                    text: use_language.delete,
                    value: 'delete',
                    align: 'center',
                    sortable: false,
                    width: 10,
                  },
                ]"
                :items="showItemSelect"
                :items-per-page="99999"
                hide-default-footer
                class="packhai-border-table packhai-table"
              >
                <template v-slot:no-data>
                  <span v-if="!promotion.joinProgram">{{
                    use_language.please_select_product
                  }}</span>
                  <span v-if="promotion.joinProgram">{{ use_language.all_participating_product }}</span>
                </template>
                <template v-slot:item.index="{ item }">
                  {{ productList.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.name="{ item }">
                  <v-row>
                    <v-col cols="12" align="left" class="pa-0">
                      <span class="fn-13" style="font-weight: bold">{{ item.name }}</span>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" align="left" class="pa-0">
                      <span class="color-gray-13"
                        >{{ !item.barcode ? "" : use_language.barcode + " : " }}
                        {{ item.barcode }}</span
                      >
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" align="left" class="pa-0">
                      <span class="color-gray-13">
                        {{ !item.productCode ? "" : use_language.number_product + " : " }}
                        {{ item.productCode }}
                        {{
                          item.productCode &&
                          (item.prop1Description || item.prop2Description)
                            ? ","
                            : ""
                        }}
                        {{
                          !item.prop1Description && !item.prop2Description
                            ? ""
                            : use_language.type + "  : "
                        }}
                        {{ item.prop1Description }} {{ item.prop2Description }}
                      </span>
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:item.photoLink="{ item }">
                  <a
                    v-if="item.photoLink != null && item.photoLink != ''"
                    icon
                    @click="OpenPhoto(item.photoLink)"
                  >
                    <img :src="item.photoLink" width="50" height="50" class="mt-1" />
                  </a>
                </template>
                <template v-slot:item.quantityInput="{ item }">
                  <v-text-field
                    :value="item.quantityInput"
                    @change="(value) => (item.quantityInput = value)"
                    autocomplete="off"
                    dense
                    hide-details
                    outlined
                    :disabled="nowdateCheck"
                    ref="quantityInput"
                    type="number"
                    @blur="sumQuentityJoinTable(item)"
                  ></v-text-field>
                  <!-- <span v-if="quantityInput_error != null" class="my-1" style="color: red;">{{ quantityInput_error }}</span> -->
                </template>
                <template v-slot:item.delete="{ item }">
                  <v-btn v-if="nowdateCheck || !canEdit" icon disabled
                    ><v-icon>mdi-delete-outline</v-icon></v-btn
                  >
                  <v-btn
                    v-else
                    icon
                    color="red"
                    @click="handleDeleteProductTableClick(item, 1)"
                    ><v-icon>mdi-delete-outline</v-icon></v-btn
                  >
                </template>
              </v-data-table>
              <v-divider></v-divider>
              <v-row justify="end" v-if="this.joinPromotion.totalquantity > 0">
                <v-col lg="2">
                  <v-row class="py-3">
                    <v-col> {{ use_language.total_quantity }} </v-col>
                    <v-col cols="12" lg="5" align="left">
                      <b>{{ formatMoney(this.joinPromotion.totalquantity) }} {{ use_language.piece_unit }}</b>
                    </v-col>
                    <v-col class="py-2">
                      <span
                        v-if="validateRules.totalquantityValidateText != null"
                        style="color: red"
                        >{{ validateRules.totalquantityValidateText }}</span
                      >
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- สินค้าที่ไม่ร่วมรายการ  -->
          <v-row class="pt-5">
            <v-col cols="12" md="3" lg="2" class="pt-1 pb-2">
              <h3 class="fn-14">{{ use_language.item_exclude_promotion }} :</h3>
            </v-col>
            <v-col cols="12" md="3" lg="2" class="pt-1 pb-2">
              <v-radio-group
                v-model="promotion.notjoinProgram"
                row
                required
                :disabled="nowdateCheck"
                class="mb-2 is-cod-selector"
                dense
                hide-details
              >
                <v-radio :label="use_language.have" :value="true">
                  <template v-slot:label> <span>{{ use_language.have }}</span> </template>
                </v-radio>
                <v-radio :label="use_language.not_have" :value="false">
                  <template v-slot:label> <span>{{ use_language.not_have }}</span> </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="promotion.notjoinProgram">
            <v-col class="pb-0" align="left">
              <v-btn
                color="primary"
                class="mr-1"
                outlined
                :disabled="nowdateCheck"
                @click="handleOpenDialogJoinPromotion(limits, 0, 2)"
              >
                <v-icon center>mdi-plus</v-icon>
                {{ use_language.select_product }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0">
              <v-data-table
                :headers="[
                  {
                    text: '#',
                    value: 'index',
                    align: 'center',
                    sortable: false,
                    width: 10,
                  },
                  {
                    text: use_language.picture,
                    value: 'photoLink',
                    align: 'center',
                    sortable: false,
                    width: '50px',
                  },
                  {
                    text: 'SKU',
                    value: 'sku',
                    align: 'center',
                    sortable: false,
                    width: '80px',
                  },
                  {
                    text: use_language.name_product,
                    value: 'name',
                    align: 'left',
                    sortable: false,
                    width: '400px',
                  },
                  {
                    text: use_language.delete,
                    value: 'delete',
                    align: 'center',
                    sortable: false,
                    width: 10,
                  },
                ]"
                :items="notjoinproductList"
                :items-per-page="99999"
                hide-default-footer
                class="packhai-border-table packhai-table"
              >
                <template v-slot:no-data>
                  <span v-if="promotion.notjoinProgram">{{
                    use_language.please_select_product
                  }}</span>
                  <span v-if="!promotion.notjoinProgram">{{ use_language.all_participating_product }}</span>
                </template>
                <template v-slot:item.index="{ item }">
                  {{ notjoinproductList.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.name="{ item }">
                  <v-row>
                    <v-col cols="12" align="left" class="pa-0">
                      <span class="fn-13" style="font-weight: bold">{{ item.name }}</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" align="left" class="pa-0">
                      <span class="color-gray-13"
                        >{{ !item.barcode ? "" : use_language.barcode + " : " }}
                        {{ item.barcode }}</span
                      >
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" align="left" class="pa-0">
                      <span class="color-gray-13">
                        {{ !item.productCode ? "" : use_language.number_product + " : " }}
                        {{ item.productCode }}
                        {{
                          item.productCode &&
                          (item.prop1Description || item.prop2Description)
                            ? ","
                            : ""
                        }}
                        {{
                          !item.prop1Description && !item.prop2Description
                            ? ""
                            : use_language.type + "  : "
                        }}
                        {{ item.prop1Description }} {{ item.prop2Description }}
                      </span>
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:item.photoLink="{ item }">
                  <a
                    v-if="item.photoLink != null && item.photoLink != ''"
                    icon
                    @click="OpenPhoto(item.photoLink)"
                  >
                    <img :src="item.photoLink" width="50" height="50" class="mt-1" />
                  </a>
                </template>
                <template v-slot:item.delete="{ item }">
                  <v-btn v-if="nowdateCheck || !canEdit" icon disabled
                    ><v-icon>mdi-delete-outline</v-icon></v-btn
                  >
                  <v-btn
                    v-else
                    icon
                    color="red"
                    @click="handleDeleteProductTableClick(item, 2)"
                    ><v-icon>mdi-delete-outline</v-icon></v-btn
                  >
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <!-- ประเภทการแถม -->
          <v-row class="pt-5">
            <v-col cols="12" md="3" lg="2" class="pt-1 pb-2">
              <h3 class="fn-14">{{ use_language.type_of_free }} :</h3>
            </v-col>
            <v-col cols="12" md="3" lg="4" class="pt-1 pb-2">
              <v-radio-group
                v-model="promotion.productFreeType"
                row
                required
                :disabled="nowdateCheck"
                class="mb-2 is-cod-selector"
                dense
                hide-details
              >
                <v-radio :label="use_language.while_supplie_last" :value="1">
                  <template v-slot:label><span>{{ use_language.while_supplie_last }}</span> </template>
                </v-radio>
                <v-radio :label="use_language.limit_to" :value="2">
                  <template v-slot:label>
                    <span>{{ use_language.limit_to }} </span>
                    <v-row v-if="promotion.productFreeType === 2">
                      <v-col>
                        <v-text-field
                          :value="promotion.productFreeOrder"
                          @change="
                            (value) =>
                              (promotion.productFreeOrder = Trim_value(value).replaceAll(',', ''))
                          "
                          outlined
                          :disabled="nowdateCheck"
                          :rules="validateRules.freeMinOrderRules"
                          ref="reffreeMinOrder"
                          dense
                          hide-details
                          autocomplete="off"
                        ></v-text-field>
                        <span
                          v-if="validateRules.freeMinOrderValidateText != null"
                          style="color: red"
                          >{{ validateRules.freeMinOrderValidateText }}</span
                        >
                      </v-col>
                      <v-col class="pt-5">
                        <span>{{ use_language.order }} </span>
                      </v-col>
                    </v-row>
                  </template>
                </v-radio>
                <v-radio :label="use_language.limit_quantity" :value="3">
                  <template v-slot:label> <span>{{ use_language.limit_quantity }}</span> </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0" align="left">
              <v-btn
                color="primary"
                class="mr-1"
                outlined
                @click="handleOpenDialogJoinPromotion(limits, 0, 3)"
                :disabled="nowdateCheck"
              >
                <v-icon center>mdi-plus</v-icon>
                {{ use_language.select_product }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0">
              <v-data-table
                :headers="freeProductHeader"
                :items="freeProductList"
                :items-per-page="99999"
                hide-default-footer
                class="packhai-border-table packhai-table"
              >
                <template v-slot:no-data><span>{{ use_language.please_select_product }}</span> </template>
                <template v-slot:item.index="{ item }">
                  {{ freeProductList.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.name="{ item }">
                  <v-row>
                    <v-col cols="12" align="left" class="pa-0">
                      <span class="fn-13" style="font-weight: bold">{{ item.name }}</span>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" align="left" class="pa-0">
                      <span class="color-gray-13"
                        >{{ !item.barcode ? "" : use_language.barcode + " : " }}
                        {{ item.barcode }}</span
                      >
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" align="left" class="pa-0">
                      <span class="color-gray-13">
                        {{ !item.productCode ? "" : use_language.number_product + " : " }}
                        {{ item.productCode }}
                        {{
                          item.productCode &&
                          (item.prop1Description || item.prop2Description)
                            ? ","
                            : ""
                        }}
                        {{
                          !item.prop1Description && !item.prop2Description
                            ? ""
                            : use_language.type + "  : "
                        }}
                        {{ item.prop1Description }} {{ item.prop2Description }}
                      </span>
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:item.photoLink="{ item }">
                  <a
                    v-if="item.photoLink != null && item.photoLink != ''"
                    icon
                    @click="OpenPhoto(item.photoLink)"
                  >
                    <img :src="item.photoLink" width="50" height="50" class="mt-1" />
                  </a>
                </template>
                <template v-slot:item.quantityInput="{ item }">
                  <v-text-field
                    :value="item.quantityInput"
                    @change="(value) => (item.quantityInput = value)"
                    autocomplete="off"
                    dense
                    hide-details
                    outlined
                    :rules="validateRules.freeMinquantityRules"
                    ref="quantityInputfree"
                    type="number"
                    @blur="sumQuentityFreeTable(item)"
                  ></v-text-field>
                  <span
                    v-if="
                      item.quantityInput <= 0 && validateRules.freeMinquantityText != null
                    "
                    class="my-1"
                    style="color: red"
                    >{{ validateRules.freeMinquantityText }}</span
                  >
                </template>
                <template v-slot:item.limitquantityInput="{ item }">
                  <v-text-field
                    :value="item.limitquantityInput"
                    @change="(value) => (item.limitquantityInput = value)"
                    autocomplete="off"
                    dense
                    hide-details
                    outlined
                    type="number"
                    @blur="sumQuentityFreeTable(item)"
                  ></v-text-field>
                </template>
                <template v-slot:item.giveAwayQuantity="{ item }">
                  <b>{{ formatMoney(item.giveAwayQuantity) }} {{ use_language.piece_unit }}</b>
                </template>
                <template v-slot:item.delete="{ item }">
                  <v-btn v-if="nowdateCheck || !canEdit" icon disabled
                    ><v-icon>mdi-delete-outline</v-icon></v-btn
                  >
                  <v-btn
                    v-else
                    icon
                    color="red"
                    @click="handleDeleteProductTableClick(item, 3)"
                    ><v-icon>mdi-delete-outline</v-icon></v-btn
                  >
                </template>
              </v-data-table>
              <v-divider></v-divider>
              <v-row justify="end" v-if="joinPromotion.freeTotalquantity > 0">
               
                   
                    <v-col cols="12" lg="5" align="right">
                        {{ use_language.total_quantity }}  
                      <b>{{ formatMoney(joinPromotion.freeTotalquantity) }} {{ use_language.piece_unit }}</b>
                    </v-col>
                    <!-- {{ validateRules.freelimitValidateText }} -->
                
              </v-row>
            </v-col>
          </v-row>
        </v-form>
        <div v-show="nowdateCheck"></div>
      </v-card-text>
      <v-card-actions class="py-5">
        <v-row>
          <v-col cols="12" align="right">
            <v-btn
              v-if="nowdateCheck || !canEdit"
              :elevation="1"
              color="primary"
              class="px-5"
              disabled
            >
              <v-icon size="20" class="mr-1">mdi-content-save</v-icon>
              <span class="fn-14"
                ><b> {{ use_language.record }} </b></span
              >
            </v-btn>
            <v-btn
              v-else
              :elevation="1"
              color="primary"
              class="px-5"
              @click="handleAddPromotionClick()"
            >
              <v-icon size="20" class="mr-1">mdi-content-save</v-icon>
              <span class="fn-14"
                ><b> {{ use_language.record }} </b></span
              >
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <v-card v-if="PromotionID != null">
      <v-card-title>
        <v-row>
          <v-col cols="12" md="6">
            <h3 class="fn-14">
              {{ use_language.total_order_free }} {{ orderMaster.total }} {{ use_language.order }}
            </h3>
          </v-col>
          <v-col cols="12" md="6" align="right">
            <vue-excel-xlsx
              id="GetExcelAll"
              v-show="false"
              :data="orderMaster.dataExcel"
              :columns="orderMaster.headerExcel"
              :filename="ExcelFile"
              :sheet-name="'sheet1'"
            >
            </vue-excel-xlsx>
            <v-btn
              :elevation="1"
              outlined
              color="success"
              class="pa-2 ml-2"
              :disabled="orderMaster.data.length < 1"
              @click="exportexcel()"
            >
              <v-icon size="14" class="pr-1">fa-solid fa-download</v-icon>
              <span class="fn-12"> Export Excel </span>
              <span v-if="orderMaster.loadingExcel != 0"
                >({{ orderMaster.loadingExcel }}%)</span
              >
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col class="pb-0" cols="12">
            <v-data-table
              :headers="orderMaster.headers"
              :items="orderMaster.data"
              :items-per-page="99999"
              hide-default-footer
              class="packhai-border-table packhai-table"
            >
              <template v-slot:no-data><span>{{ use_language.no_order_receive }}</span> </template>
              <template v-slot:item.No="{ item }">
                {{
                  orderMaster.total - orderMaster.offsets - orderMaster.data.indexOf(item)
                }}
              </template>
              <template v-slot:item.orderMasterID="{ item }">
                <a class="text-info" @click="detail_page(item.orderMasterID)">{{
                  FormatOrder(item.orderMasterID)
                }}</a>
              </template>
              <template v-slot:item.referenceSourceID="{ item }">
                <a v-if="item.channelLogo != null && item.channelLogo != ''" icon>
                  <img :src="item.channelLogo" width="30" height="30" class="mt-1" />
                </a>
              </template>
              <template v-slot:item.totalPrice="{ item }">
                <span>{{ formatMoneyIsDecimal(item.totalPrice) }}</span>
              </template>
               <template v-slot:item.totalSellerDiscount="{ item }">
                <span v-if="item.totalSellerDiscount==0"></span>
                <span v-else>{{ formatMoneyIsDecimal(item.totalSellerDiscount) }}</span>
              </template>
              <template v-slot:item.totalPlatformDiscount="{ item }">
                <span v-if="item.totalPlatformDiscount==0"></span>
                <span v-else>{{ formatMoneyIsDecimal(item.totalPlatformDiscount) }}</span>
              </template>
              <template v-slot:item.deliveryCost="{ item }">
                <span v-if="item.deliveryCost==0"></span>
                <span v-else>{{ formatMoneyIsDecimal(item.deliveryCost) }}</span>
              </template>
               <template v-slot:item.sellerDeliveryDiscount="{ item }">
                <span v-if="item.sellerDeliveryDiscount==0"></span>
                <span v-else>{{ formatMoneyIsDecimal((item.sellerDeliveryDiscount)) }}</span>
              </template>
              <template v-slot:item.orderTotalAmount="{ item }">
                <span>{{ formatMoneyIsDecimal(item.orderTotalAmount) }}</span>
              </template>
            </v-data-table>
            <div
              v-if="orderMaster.pageLength > 1 && orderMaster.data.length > 0"
              class="text-center pa-1"
              @click="changePageOrderMaster()"
            >
              <v-pagination
                v-model="orderMaster.page"
                :length="orderMaster.pageLength"
                :total-visible="orderMaster.pageTotalVisible"
                color="error"
              ></v-pagination>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="joinPromotion.dialog" persistent scrollable max-width="80%">
      <v-card elevation="1" class="ma-0">
        <v-card-title class="height-57 pa-0">
          <div class="v-list-item">
            <div class="pa-2">
              <v-select style="width:150px"
                v-model="SearchBy"
                :label="use_language.search_by"
                :items="SearchByList"
                item-text="text"
                item-value="value"
                outlined
                dense hide-details
              ></v-select>
            </div>
            <div class="pa-2">
              <v-select style="width:150px"
                v-model="SearchType"
                :label="use_language.search_by_type"
                :items="SearchTypeList"
                item-text="text"
                item-value="value"
                outlined
                dense hide-details
              ></v-select>
            </div>
            <div class="v-list-item__content pa-2">
              <v-text-field
                ref="refsearchProductPopup"
                :value="joinPromotion.searchProductPopup"
                autocomplete="off"
                class="pl-2"
                dense
                hide-details
                @change="
                  (value) => (joinPromotion.searchProductPopup = Trim_value(value))
                "
                @keyup.enter="PopupsearchStock(limits, 0)"
              ></v-text-field>
            </div>
            <div class="pa-2">
              <v-btn
                color="primary"
                class="mr-1 px-2"
                @click="PopupsearchStock(limits, 0)"
              >
                <v-icon center>mdi-magnify</v-icon>
                {{ use_language.search }}
              </v-btn>
            </div>
            <div>
              <v-btn icon @click="joinPromotion.dialog = false"
                ><v-icon color="danger">mdi-close</v-icon></v-btn
              >
            </div>
          </div>
        </v-card-title>
        <v-divider />

        <!-- PC -->
        <v-card-text class="overflow-x-auto pt-1 pb-1 hidden-xs-only">
          <v-data-table
            :headers="joinPromotion.headers"
            :items="joinPromotion.data"
            item-key="id"
            :items-per-page="999999"
            hide-default-footer
            class="elevation-0 packhai-checkbox-select"
          >
            <template v-slot:[`header.selectProduct`]>
              <v-checkbox
                v-model="isAllSelected"
                @change="toggleSelectAll"
                hide-details
                dense
                color="primary"
              />
            </template>
            <template v-slot:item.selectProduct="{ item }">
              <v-checkbox
                :input-value="isItemSelected(item)"
                @change="toggleItem(item)"
                color="red"
                hide-details
                dense
              ></v-checkbox>
            </template>
            <template v-slot:item.No="{ item }">
              {{ joinPromotion.data.indexOf(item) + 1 + offsets }}
            </template>
            <template v-slot:item.photoLink="{ item }">
              <v-btn
                v-if="item.photoLink != null && item.photoLink != ''"
                icon
                @click="OpenPhoto(item.photoLink)"
              >
                <img :src="item.photoLink" height="30" />
              </v-btn>
            </template>
            <template v-slot:item.name="{ item }">
              {{ item.name }}
            </template>
            <template v-slot:item.prop1="{ item }">
              <span class="fn-13">
                {{
                  (item.prop1_Description != null && item.prop1_Description != ""
                    ? item.prop1_Description
                    : "") +
                  (item.prop2_Description != null && item.prop2_Description != ""
                    ? " , " + item.prop2_Description
                    : "")
                }}
              </span>
            </template>
            <template v-slot:item.salePrice="{ item }">
              <span>
                {{
                  formatMoney(
                    item.salePrice == null || item.salePrice == "" || item.salePrice == 0
                      ? "0.00"
                      : item.salePrice
                  )
                }}
              </span>
            </template>
          </v-data-table>
        </v-card-text>
        <!-- PC -->

        <div
          v-if="pageLength > 1 && joinPromotion.data.length > 0"
          class="text-center pa-1"
          @click="changePage()"
        >
          <v-pagination
            v-model="page"
            :length="pageLength"
            :total-visible="pageTotalVisible"
            color="error"
          ></v-pagination>
        </div>

        <v-divider />
        <div class="height-57 pa-2" align="right">
          <v-btn color="primary" class="mr-2" :disabled="nowdateCheck || !canEdit" @click="handleAddProductClick()">
            {{ use_language.ad_product }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- แสดงภาพ -->
    <v-dialog v-model="ShowPhoto" max-width="500">
      <v-card class="ma-0">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" class="text-center">
              <img class="hidden-md-and-up" :src="ShowPhotoLink" width="300" />
              <img class="hidden-sm-and-down" :src="ShowPhotoLink" width="450" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn text color="#1976d2" @click="Opentap(ShowPhotoLink)">{{
            use_language.newtab
          }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="#1976d2" @click="ShowPhoto = false">{{
            use_language.close
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Loading from "@/website/components/Loading";
import axios from "axios";
import Swal from "sweetalert2";
import { shopService_dotnet } from "@/website/global";
import {
  formatDatetime,
  formatMoney,
  formatMoneyIsDecimal,
  isNumberWNoDot,
  isNumberWithDot,
  isNumberWitMark,
  Trim_value,
  set_format_date_time,
  format_vat_type,
  format_price,
  get_languages,
  GenIE,
  GenPA,
  FormatOrder,
  checkAuthorize,
} from "@/website/global_function";
export default {
  components: {
    Loading,
  },
  data: () => ({
    BranchID : parseInt(localStorage.getItem("branch_id")),
    header_token:{'Content-Type': 'application/json', 'Authorization': 'Bearer '+localStorage.getItem('authorization_token')},
    page_loading: true,
    SearchBy: "sku",
    SearchByList: [],
    SearchType: true,
    SearchTypeList: [],
    loading: false,
    shopID: null,
    productList: [],
    notjoinproductList: [],
    freeProductList: [],
    productImportType: null,
    isedit: false,
    PromotionID: null,
    nowdateCheck: false,
    startDateMenu: false,
    startDatePromotion: '',
    formattedStartDate: '',
    endDateMenu: false,
    endDatePromotion: '',
    formattedEndDate: '',
    promotion: {
      name: null,
      channel: [],
      promotionType: 1,
      productFreeType: 1,
      isUseMultiplier:false,
      productFreeOrder: null,
      amount: null,
      quantity: null,
      duplicate: true,
      priority: null,
      joinProgram: true,
      notjoinProgram: false,
      selectedHourStart: null,
      selectedHourEnd: null,
      hours: [],
      deleteItemIDlist: [],
    },
    joinPromotion: {
      headers: [],
      data: [],
      productSelect: [],
      dialog: false,
      searchProductPopup: null,
      searchNamePopup: null,
      totalquantity: 0,
      freeTotalquantity: 0,
      limitTotalquantity: 0,
    },
    notJoinPromotion: {
      productnotjoin: false,
    },
    marketpalce: {
      shopee: [],
      lazada: [],
      tiktok: [],
      woo: [],
      linemyshop: [],
      shopify: [],
      allData: [],
      selectMarketpalce: [],
    },
    ExcelFile:'',
    orderMaster: {
      
      headers: [],
      data: [],
      orderID: null,
      //excel
      headerExcel: [],
      dataExcel: [],
      loadingExcel: 0,
      // paginations
      page: 1,
      pageTemp: 1,
      pageLength: 1,
      pageTotalVisible: 9,
      limits: 10,
      offsets: 0,
      total: 0,
    },
    synnexBranch:[727,714],
    validateRules: {
      promotionNameRules: [],
      promotionNameValidateText: null,
      channelRules: [],
      channelRulesValidateText: null,
      priorityRules:[],
      priorityValidateText:null,
      amountRules: [],
      amountValidateText: null,
      quantityRules: [],
      quantityValidateText: null,
      totalquantityValidateText: null,
      freeMinOrderValidateText: null,
      freeMinOrderRules: [],
      freeMinquantityRules: [],
      freeMinquantityText: null,
      freelimitValidateText: null,
    },

    // แสดงภาพ
    ShowPhoto: false,
    ShowPhotoLink: "",

    // paginations
    page: 1,
    pageTemp: 1,
    pageLength: 1,
    pageTotalVisible: 9,
    limits: 10,
    offsets: 0,
    total: 0,
    formatDataTabel: true,

    // time picker
    timeStart:
      Number(new Date().toISOString().substr(11, 2)) +
      7 +
      ":" +
      new Date().toISOString().substr(14, 2),
    time_pickerStart: false,
    timeEnd:
      Number(new Date().toISOString().substr(11, 2)) +
      7 +
      ":" +
      new Date().toISOString().substr(14, 2),
    time_pickerEnd: false,

    // ตามวันที่
     
    disableDate: false,
  }),
  computed: {
    canEdit() {
      return checkAuthorize(44);
    },
    isAllSelected: {
      get() {
        const data = this.joinPromotion && this.joinPromotion.data;
        const list = this.joinPromotion && this.joinPromotion.productSelect;
        if (!data || data.length === 0 || !list) return false;
        const selectedIds = new Set(list.map((p) => p.id));
        // checked เมื่อทุก item ในหน้าปัจจุบันอยู่ใน productSelect
        return data.every((item) => selectedIds.has(item.id));
      },
      // empty setter — งานจริงทำใน @change="toggleSelectAll"
      // (จำเป็นต้องมี setter เพราะ v-model ต้องเขียน — ถ้าไม่มี Vue 2 จะ warn)
      set() {},
    },
    freeProductHeader() {
      let header = [
        { text: "#", value: "index", align: "center", sortable: false, width: 10 },
        { text: this.use_language.picture_, value: "photoLink", align: "center", sortable: false, width: "50px" },
        { text: "SKU", value: "sku", align: "center", sortable: false, width: "80px" },
        { text: this.use_language.details, value: "name", align: "left", sortable: false, width: "400px" },
        { text: this.use_language.quantity_free_item, value: "quantityInput", align: "center", sortable: false, width: "120px", },
        { text: this.use_language.limit_quantity, value: "limitquantityInput", align: "center", sortable: false, width: "120px" },
        { text: this.use_language.total_give_bonus, value: "giveAwayQuantity", align: "center", sortable: false, width: "120px" },
        { text: this.use_language.delete, value: "delete", align: "center", sortable: false, width: 10 },
      ];
      if (this.promotion.productFreeType === 1 || this.promotion.productFreeType === 2) {
        const index = header.findIndex((header) => header.value === "limitquantityInput");
        if (index > -1) header.splice(index, 1);
      }
      if (!this.nowdateCheck) {
        if(!this.synnexBranch.includes(this.BranchID)){

          
          const index = header.findIndex((header) => header.value === "giveAwayQuantity");
          if (index > -1) header.splice(index, 1);
        }
      }
      return header;
    },
    texttitle() {
      var text;
      this.isedit ? (text = this.use_language.edit_promotion) : (text = this.use_language.add_promotion);
      return text;
    },
    showItemSelect() {
      if (!this.promotion.joinProgram) {
        return this.productList;
      } else {
        return [];
      }
    },
  },
  watch: {
    promotion: {
      handler(item) {
        if (this.promotionID === null) {
          if (item.joinProgram) {
            this.productList = [];
          } else if (!item.notjoinProgram) {
            this.notjoinproductList = [];
          }
        }
      },
      deep: true,
    },
  },
  async created() {
    //เก็บภาษามาไว้ใน use_language
    this.use_language = await this.get_languages(localStorage.getItem("set_language"));
    this.setMultiLanguage()
    this.shopID = parseInt(localStorage.getItem("shop_id"));
    await this.getAllMarketpalce();
  
    this.PromotionID = this.$route.query.id
    if (this.PromotionID != null || this.PromotionID != undefined) {
      this.isedit = true;
      
      await this.getPromotionForEdit(this.PromotionID);
      await this.getOrderMasterFreeProductList(this.orderMaster.limits, 0, 1, null);
    } else{
      var d = new Date();
      this.startDatePromotion=d.getFullYear()+"-"+(d.getMonth()+1)+"-"+d.getDate();
      this.endDatePromotion =d.getFullYear()+"-"+(d.getMonth()+1)+"-"+d.getDate();
      console.log( this.startDatePromotion);
      this.updateFormattedStartDate() 
      this.updateFormattedEndDate() 
    }
    this.page_loading = false;
  },

  methods: {
  setMultiLanguage() {
    this.SearchByList = [
      { text: "SKU", value: "sku" },
      { text: this.use_language.name_product, value: "name" },
      { text: "Barcode", value: "barcode" },
      { text: this.use_language.product_code, value: "productCode" },
    ]
    this.SearchTypeList = [
      { text: this.use_language.equal_to, value: true },
      { text: this.use_language.include, value: false },
    ]

    this.joinPromotion.headers = [
      { text: "", align: "center", sortable: false, value: "selectProduct", width: "50px" },
      { text: "No", align: "center", sortable: false, value: "No", width: "60px" },
      { text: this.use_language.picture, align: "center", sortable: false, value: "photoLink", width: "60px" },
      { text: this.use_language.name, align: "left", sortable: false, value: "name" },
      { text: this.use_language.type, align: "center", sortable: false, value: "prop1" },
      { text: this.use_language.product_code, align: "center", sortable: false, value: "productCode", width: "90px" },
      { text: "SKU", align: "center", sortable: false, value: "sku" },
      { text: "Barcode", align: "center", sortable: false, value: "barcode" },
      { text: this.use_language.price, align: "right", sortable: false, value: "salePrice",  width: "90px" },
    ]

    this.ExcelFile = this.use_language.order_free_gift,
    this.orderMaster.headers = [
      { text: "No", align: "center", sortable: false, value: "No", width: "60px" },
      { text: this.use_language.order_number, align: "left", sortable: false, value: "orderMasterID", width: "100px" },
      { text: this.use_language.reference_number, align: "left", sortable: false, value: "referenceNumber", width: "140px" },
      { text: this.use_language.payment_date, align: "left", sortable: false, value: "PaymenDate", width: "140px" },
      { text: this.use_language.channel, align: "center", sortable: false, value: "referenceSourceID", width: "60px" },
      { text: this.use_language.shop, align: "left", sortable: false, value: "marketplaceSellerName", width: "140px" },
      { text: this.use_language.product_price, align: "right", sortable: false, value: "totalPrice", width: "80px"},
      { text: this.use_language.seller_discount, align: "right", sortable: false, value: "totalSellerDiscount", width: "80px" },
      { text: this.use_language.platform_discount, align: "right", sortable: false, value: "totalPlatformDiscount", width: "80px" },
      { text: this.use_language.freight, align: "right", sortable: false, value: "deliveryCost", width: "80px"},
      { text: this.use_language.shipping_discount, align: "right", sortable: false, value: "sellerDeliveryDiscount", width: "80px" },
      { text: this.use_language.price_after_discount, align: "right", sortable: false, value: "orderTotalAmount", width: "120px" },
    ]
    this.orderMaster.headerExcel = [
      { label: "No", field: "No" },
      { label: this.use_language.order_number, field: "orderMasterID" },
      { label: this.use_language.reference_number, field: "referenceNumber" },
      { label: this.use_language.payment_date, field: "Date" },
      { label: this.use_language.channel, field: "referenceSourceID" },
      { label: this.use_language.shop, field: "marketplaceSellerName" },
      { label: this.use_language.product_price, field: "totalPrice" },
      { label: this.use_language.seller_discount, field: "totalSellerDiscount" },
      { label: this.use_language.platform_discount, field: "totalPlatformDiscount" },
      { label: this.use_language.freight, field: "deliveryCost" },
      { label: this.use_language.shipping_discount, field: "sellerDeliveryDiscount" },
      { label: this.use_language.price_after_discount, field: "orderTotalAmount" },
    ]
  },
    FormatOrder,
    formatDatetime,
    isItemSelected(item) {
      // เช็คจาก productSelect array (source of truth) — ไม่พึ่ง flag บน item
      // เพราะ flag หายไปเมื่อ pagination โหลด data ใหม่
      if (!this.joinPromotion.productSelect) return false;
      return this.joinPromotion.productSelect.some((p) => p.id === item.id);
    },
    toggleItem(item) {
      const list = this.joinPromotion.productSelect;
      const idx = list.findIndex((p) => p.id === item.id);
      if (idx >= 0) {
        list.splice(idx, 1);
      } else {
        list.splice(0, 0, item);
      }
    },
    toggleSelectAll(val) {
      // val มาจาก v-checkbox @change (boolean — สถานะใหม่ของ checkbox)
      const newVal = typeof val === "boolean" ? val : !this.isAllSelected;
      const list = this.joinPromotion.productSelect;
      if (newVal) {
        // เลือกทั้งหมดในหน้าปัจจุบัน — push เฉพาะที่ยังไม่อยู่ใน list (กันซ้ำข้ามหน้า)
        const existingIds = new Set(list.map((p) => p.id));
        this.joinPromotion.data.forEach((item) => {
          if (!existingIds.has(item.id)) {
            list.splice(0, 0, item);
          }
        });
      } else {
        // ยกเลิกทั้งหมดในหน้าปัจจุบัน — เอาออกเฉพาะที่อยู่ใน data หน้านี้
        const currentIds = new Set(
          this.joinPromotion.data.map((item) => item.id)
        );
        this.joinPromotion.productSelect = list.filter(
          (p) => !currentIds.has(p.id)
        );
      }
    },
    formatMoney,
    formatMoneyIsDecimal,
    isNumberWNoDot,
    isNumberWithDot,
    isNumberWitMark,
    set_format_date_time,
    format_vat_type,
    format_price,
    get_languages,
    GenIE,
    GenPA,
    Trim_value,
    // allowedDates: (val) => val <= new Date().toISOString().substr(0, 10),
    async handleOpenDialogJoinPromotion(limits, offsets, type) {
      this.joinPromotion.searchProductPopup = null;
      this.joinPromotion.select = [];
      this.joinPromotion.data = [];
      this.joinPromotion.productSelect = [];
      this.productImportType = type; //กำหนดtype ไว้ตอนadd product ใส่ ตาราง จะได้เรียงตารางถูก

      this.page = 1;
      this.pageTemp = 1;
      this.getSelectProduct(
        limits,
        offsets,
        this.joinPromotion.searchProductPopup,
        this.page
      );
    },
    async getOrderMasterFreeProductList(limits, offsets, page, search) {
      let response = await axios.post(
        shopService_dotnet + "Promotion/get-promotion-ordermaster",
        {
          promotionID: this.PromotionID,
          orderId: search,
          skip: offsets,
          take: limits,
        },
        { headers: this.header_token }
      );
      if (response.data.status) {
        this.orderMaster.pageTemp = page;
        this.orderMaster.offsets = offsets;
        this.orderMaster.total = response.data.dataCount;
        this.orderMaster.pageLength = Math.ceil(
          this.orderMaster.total / this.orderMaster.limits
        );
        if (this.orderMaster.pageLength <= 0) {
          this.orderMaster.pageLength = 1;
        }
        const OrderData = response.data.promotionOrderMasters.map((x) => {
          const paymentDate = new Date(x.paymentDate);
          const forma = this.formateDate(paymentDate);
          const baseObject = {
            ...x,
            PaymenDate: forma,
          };
          baseObject.referenceNumber=baseObject.referenceNumber.replace("Tiktok-","")
          baseObject.totalPlatformDiscount= baseObject.totalPlatformDiscount*-1;
          baseObject.totalSellerDiscount= baseObject.totalSellerDiscount*-1;
          baseObject.sellerDeliveryDiscount= (baseObject.sellerDeliveryDiscount+baseObject.platformDeliveryDiscount)*-1 ;
          return baseObject;
        });

        this.orderMaster.data = OrderData;
      }
    },
    async getSelectProduct(limits, offsets, searchstock, page) {
      this.loading = true;
      //filter product ที่เลือกไปแล้วทุกตาราง
      let selectAllProduct=[];
      if(this.productImportType==1){
        selectAllProduct = [
        ...this.productList.map((item) => item.id)  ];
      }else if(this.productImportType==2){
        selectAllProduct = [ 
        ...this.notjoinproductList.map((item) => item.id)  ];
      }else if(this.productImportType==3){
        selectAllProduct = [ 
        ...this.freeProductList.map((item) => item.id) ];
      }
      let searchList = null;
      if (searchstock) {
        if (this.SearchBy == "name") {
          searchList = searchstock
            .split(",")
            .map((item) => item.trim())
            .filter((item) => item.length > 0);
        } else {
          searchList = searchstock
            .split(/[,\s]+/)
            .map((item) => item.trim())
            .filter((item) => item.length > 0);
        }
      }
      
      let response = await axios.post(
        shopService_dotnet + "Promotion/get-stock-product-for-promotion",
        {
          name: this.SearchBy == "name" ? searchList : null,
          productCode: this.SearchBy == "productCode" ? searchList : null,
          barcode: this.SearchBy == "barcode" ? searchList : null,
          sku: this.SearchBy == "sku" ? searchList : null,
          shopID: this.shopID,
          skipID: selectAllProduct,
          isEqual: this.SearchType,
          skip: offsets,
          take: limits,
        },
        { headers: this.header_token }
      );

      if (response.status == 200) {
        this.pageLength = Math.ceil(response.data.searchResultCount / this.limits);
        if (this.pageLength <= 0) {
          this.pageLength = 1;
        }
        this.page = page;
        this.pageTemp = page;

        this.joinPromotion.data = response.data.productItem;
        this.joinPromotion.dialog = true;
        this.loading = false;
      } else {
        this.loading = false;
        this.$swal({
          position: "top",
          type: "error",
          text: this.use_language.cannot_perform_operation,
        });
      }
    },
    async getAllMarketpalce() {
      this.loading = true;
      let response = await axios.get(
        shopService_dotnet +
          "Promotion/get-marketplace-for-promotion?ShopID=" +
          this.shopID,
        { headers: this.header_token }
      );
      if (response.status == 200) {
        var photo;
        var shop_shopee = [];
        var shop_lazada = [];
        var shop_tiktok = [];
        var shop_Woo = [];
        var shop_Line = [];
        var shop_Shopify = [];
        if (response.data.shopee_Shop.length > 0) {
          photo = "https://seeklogo.com/images/S/shopee-logo-DD5CAE562A-seeklogo.com.png";
          shop_shopee = await this.formatDataMarketplace(
            response.data.shopee_Shop,
            photo,
            3
          );
        }
        if (response.data.lazada_Shop.length > 0) {
          photo =
            "https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/lazada.png";
          shop_lazada = await this.formatDataMarketplace(
            response.data.lazada_Shop,
            photo,
            4
          );
        }
        if (response.data.tiktok_Shop.length > 0) {
          photo =
            "https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/TikTok-Logo-1.png";
          shop_tiktok = await this.formatDataMarketplace(
            response.data.tiktok_Shop,
            photo,
            11
          );
        }
        if (response.data.shop_Woo.length > 0) {
          photo = "https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/woo.png";
          shop_Woo = await this.formatDataMarketplace(response.data.shop_Woo, photo, 144);
        }
        if (response.data.shop_Line.length > 0) {
          photo =
            "https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/linemyshop.png";
          shop_Line = await this.formatDataMarketplace(response.data.shop_Line, photo, 8);
        }
        if (response.data.shop_Shopify.length > 0) {
          photo =
            "https://packhaistorage.s3.ap-southeast-1.amazonaws.com/image/Screenshot+2024-03-09+004759.png";
          shop_Shopify = await this.formatDataMarketplace(
            response.data.shop_Shopify,
            photo,
            6
          );
        }
        var shop_Amaze = [];
        if (response.data.shop_Amaze && response.data.shop_Amaze.length > 0) {
          photo = response.data.shop_Amaze[0].logo;
          shop_Amaze = await this.formatDataMarketplace(response.data.shop_Amaze, photo, 1437);
        }
        var shop_Makro = [];
        if (response.data.shop_Makro && response.data.shop_Makro.length > 0) {
          photo = response.data.shop_Makro[0].logo;
          shop_Makro = await this.formatDataMarketplace(response.data.shop_Makro, photo, 1341);
        }
        this.marketpalce.allData = [
          shop_shopee,
          shop_lazada,
          shop_tiktok,
          shop_Woo,
          shop_Line,
          shop_Shopify,
          shop_Amaze,
          shop_Makro,
        ].reduce((acc, curr) => acc.concat(curr), []);
        this.loading = false;
      } else {
        this.loading = false;
        this.$swal({
          position: "top",
          type: "error",
          text: this.use_language.cannot_perform_operation,
        });
      }
    },
    async getPromotionForEdit(promotionID) {
      this.loading = true;
      let response = await axios.get(
        shopService_dotnet +
          "Promotion/get-pomotion-for-edit?PromotionID=" +
          promotionID +
          "&ShopID=" +
          this.shopID,
        { headers: this.header_token }
      );
      if (response.data.status) {
        const promotion = response.data.promotion;
        this.promotion.name = promotion.name;
        document.title=promotion.name;
        this.promotion.promotionType = promotion.promotionType;
        this.promotion.quantity = promotion.minQuantity;
        this.promotion.amount = promotion.minSpend;
        this.promotion.priority = promotion.priority;
        this.promotion.isUseMultiplier = promotion.isUseMultiplier;
        this.promotion.duplicate = promotion.isOverlapped;
        var checkstartDate = new Date(promotion.startDate);
        var nowdate = new Date();
        // เปรียบเทียบเวลา
        if(this.synnexBranch.includes(this.BranchID)){
          this.nowdateCheck = false;
        }else{
          if (checkstartDate.getTime() > nowdate.getTime()) {
            this.nowdateCheck = false;
          } else {
            this.nowdateCheck = true;
          }
        }
       
     
        this.startDatePromotion=promotion.startDate.substring(0,10) ;
        this.endDatePromotion =promotion.endDate.substring(0,10) ;
        this.updateFormattedStartDate() 
        this.updateFormattedEndDate() 

 
        this.timeStart = promotion.startDate.substring(11,16);
        this.timeEnd = promotion.endDate.substring(11,16);

        this.promotion.productFreeOrder = promotion.minOrderFreeProduct;
        this.promotion.productFreeType = promotion.freePromotionType;
        //
        const promotionitem = response.data.promotionItems;
        for (var i of promotionitem) {
          if (i.productType === 1) {
            if (i.productMasterItem !== null) {
              this.promotion.joinProgram = false;
              let productItemList = { ...i.productMasterItem };
              productItemList.quantityInput = i.quantity;
              productItemList.promotionitemID = i.id;
              this.productList.push(productItemList);
              this.sumQuentityJoinTable(i.quantity);
            }
          }
          if (i.productType === 2) {
            if (i.productMasterItem !== null) {
              this.promotion.notjoinProgram = true;
              let notjoinitemproductList = { ...i.productMasterItem };
              notjoinitemproductList.promotionitemID = i.id;
              this.notjoinproductList.push(notjoinitemproductList);
            }
          }
          if (i.productType === 3) {
            if (i.productMasterItem !== null) {
              let freeproductItemList = { ...i.productMasterItem };
              freeproductItemList.quantityInput = i.quantity;
              freeproductItemList.promotionitemID = i.id;
              freeproductItemList.limitquantityInput = i.limitQuantity;
              freeproductItemList.giveAwayQuantity = i.giveAwayQuantity;
              this.freeProductList.push(freeproductItemList);
              this.sumQuentityFreeTable(i.quantity);
            }
          }
        }
        //
        const promotionMarketplace = response.data.promotionChannels;

         // จับคู่ด้วย channel + seller เพราะ seller id ของ Woo/LINE/Shopify/Amaze เป็นเลข ID ของตารางร้าน อาจซ้ำข้ามช่องทาง
        var data = promotionMarketplace.filter((x) =>
          this.marketpalce.allData.some((i) => i.sellerID === x.platformSellerID && i.channelID === x.referenceSourceID)
        );
        const idsSet = new Set(data.map((item) => item.referenceSourceID + "-" + item.platformSellerID));
        this.marketpalce.allData.forEach((item, index) => {
          if (idsSet.has(item.channelID + "-" + item.sellerID)) {
            const findIDmatching = promotionMarketplace.find(
              (pm) => pm.platformSellerID === item.sellerID && pm.referenceSourceID === item.channelID
            );
            if (findIDmatching) {
              this.$set(this.marketpalce.allData, index, {
                ...item,
                selectSeller: true,
                uniqueID: findIDmatching.id,
              });
            }
          }
        });
        this.marketpalce.allData.forEach((item) => {
          this.handleSelectCheckboxMarketplace(item);
        });
        this.loading = false;
      }
    },
    handleSelectCheckboxProduct(item) {
      if (item["selectProduct"]) {
        this.joinPromotion.productSelect.splice(0, 0, item);
      } else {
        var data = this.joinPromotion.productSelect;
        for (var i in data) {
          if (data[i]["id"] == item["id"]) {
            this.joinPromotion.productSelect.splice(i, 1);
            break;
          }
        }
      }
    },
    handleSelectCheckboxMarketplace(item) {
      if (item.selectSeller) {
        this.marketpalce.selectMarketpalce.splice(0, 0, item);
      } else {
        const removeitem = this.marketpalce.selectMarketpalce.findIndex(
          (selectedItem) => selectedItem === item
        );
        if (removeitem !== -1) {
          this.marketpalce.selectMarketpalce.splice(removeitem, 1);
        }
      }
    },
    async handleAddProductClick() {
      let targetList;
      switch (this.productImportType) {
        case 1:
          targetList = this.productList;
          break;
        case 2:
          targetList = this.notjoinproductList;
          break;
        case 3:
          targetList = this.freeProductList;
          break;
      }
      for (let product of this.joinPromotion.productSelect) {
        targetList.push(product);
      }
      this.joinPromotion.dialog = false;
    },
    async handleDeleteProductTableClick(item, type) {
      if (!this.canEdit) return;   // ดูอย่างเดียว: ห้ามลบสินค้า
      let list;
      switch (type) {
        case 1:
          list = this.productList;
          this.joinPromotion.totalquantity -= item.quantityInput;
          break;
        case 2:
          list = this.notjoinproductList;
          break;
        case 3:
          list = this.freeProductList;
          this.joinPromotion.freeTotalquantity -= item.quantityInput;
          this.joinPromotion.limitTotalquantity -= item.limitquantityInput;
          break;
      }
      const index = list.indexOf(item);
      if (index > -1) {
        list.splice(index, 1);
      }

      this.promotion.deleteItemIDlist.push(item.promotionitemID || 0);
    },
    async sumQuentityJoinTable() {
      var totalq = 0;
      var qq = 0;
      // วนลูปจำนวนทั้งหมดตามlength ของ productList
      this.productList.forEach((e, index) => {
        qq = Number.isNaN(Number(this.productList[index].quantityInput))
          ? 0
          : Number(this.productList[index].quantityInput);
        if (qq > 0) {
          totalq += qq;
        }
      });
      this.joinPromotion.totalquantity = totalq;
    },
    async sumQuentityFreeTable() {
      var totalq = 0;
      var qq = 0;
      var limitqq = 0;
      var limittotalq = 0;
      // วนลูปจำนวนทั้งหมดตามlength ของฟรี
      this.freeProductList.forEach((e, index) => {
        qq = Number.isNaN(Number(this.freeProductList[index].quantityInput))
          ? 0
          : Number(this.freeProductList[index].quantityInput);
        limitqq = Number.isNaN(Number(this.freeProductList[index].limitquantityInput))
          ? 0
          : Number(this.freeProductList[index].limitquantityInput);
        if (qq > 0) {
          totalq += qq;
        }
        if (limitqq > 0) [(limittotalq += limitqq)];
      });
      this.joinPromotion.freeTotalquantity = totalq;
      this.joinPromotion.limitTotalquantity = limittotalq;
    },
    async PopupsearchStock(limits, offsets) {
      if (this.joinPromotion.searchProductPopup != null) {
        this.joinPromotion.searchNamePopup = this.joinPromotion.searchProductPopup.trim();
        this.loading = true;
        if (this.joinPromotion.searchNamePopup.length > 0) {
          this.getSelectProduct(limits, offsets, this.joinPromotion.searchNamePopup, 1);
        } else {
          this.getSelectProduct(limits, offsets, null, 1);
        }
      }
    },
    async handleAddPromotionClick() {
      if (!this.canEdit) return;   // ดูอย่างเดียว: ห้ามบันทึก
      await this.clearRules();
      this.loading=true;
      // if (!this.marketpalce.allData.some(x => x.selectSeller === true)) {
      //   this.validateRules.channelRules = [ v => !!v || "กรุณาระบุ" ]
      //   this.validateRules.channelRulesValidateText = 'โปรดเลือกช่องทางขายอย่างน้อย1ช่องทาง'
      //   this.$refs.channelRef.focus();
      //   return;
      // }
      var ispass=true;
      if (this.promotion.productFreeType === 2) {
        if (
          this.promotion.productFreeOrder === null ||
          this.promotion.productFreeOrder === ""
        ) {
          this.validateRules.freeMinOrderValidateText = this.use_language.please_fill;
          this.validateRules.freeMinOrderRules = [(v) => !!v || this.use_language.please_fill];
          this.$refs.reffreeMinOrder.focus();
          ispass=false;
            
        }
      }
     
      if (!this.promotion.duplicate) {
        if (this.promotion.priority === null || this.promotion.priority === "") {
          this.validateRules.priorityRules = [(v) => !!v || this.use_language.please_fill];
          this.validateRules.priorityValidateText = this.use_language.enter_priority;
          this.$refs.promotionpriority.focus();
          ispass=false;
        }
      }
      if (this.promotion.promotionType === 1) {
        if (this.promotion.amount === null || this.promotion.amount === "") {
          this.validateRules.amountRules = [(v) => !!v || this.use_language.please_fill];
          this.validateRules.amountValidateText = this.use_language.enter_sales_amount;
          this.$refs.promotionamout.focus();
          ispass=false;
        }
        else  if (parseInt(this.promotion.amount) == 0  ) {
          this.validateRules.amountRules = [(v) => !!v || this.use_language.please_fill];
          this.validateRules.amountValidateText = this.use_language.please_specify_quantity_greater_than_zero;
          this.$refs.promotionamout.focus();
          ispass=false;
        }
      }
      else if (this.promotion.promotionType === 2) {
        if (this.promotion.quantity === null || this.promotion.quantity === "") {
          this.validateRules.quantityRules = [(v) => !!v || this.use_language.please_fill];
          this.validateRules.quantityValidateText = this.use_language.please_specify_quantity;
          this.$refs.promotionquantity.focus();
          ispass=false;
        }
        else  if (parseInt(this.promotion.quantity) == 0  ) {
          this.validateRules.amountRules = [(v) => !!v || this.use_language.please_fill];
          this.validateRules.amountValidateText = this.use_language.please_specify_quantity_greater_than_zero;
          this.$refs.promotionamout.focus();
          ispass=false;
        }
      }
      if (this.promotion.name === null || this.promotion.name === "") {
        this.validateRules.promotionNameRules = [(v) => !!v || this.use_language.please_fill];
        this.validateRules.promotionNameValidateText = this.use_language.enter_promotion_name;
        this.$refs.promotionname.focus();
        ispass=false;
      }
      if(!ispass){
         this.loading=false;
        return;
      }

      
     
      
      if (!this.promotion.joinProgram && this.promotion.promotionType === 2) {
        if (this.promotion.quantity < this.joinPromotion.totalquantity) { 
          this.loading=false;
          this.$swal({ 
            type: "warning",
            text: this.use_language.participating_qty_le_total,
          });
          
          return;
         
        }
      }
      if (this.freeProductList.length > 0) {
        if (
          this.joinPromotion.freeTotalquantity === null ||
          this.joinPromotion.freeTotalquantity === 0
        ) {
          this.loading=false;
          this.validateRules.freeMinquantityRules = [(v) => !!v || this.use_language.please_fill];
          this.validateRules.freeMinquantityText = this.use_language.enter_quantity_2;
          this.$refs.quantityInputfree.focus();
          return;
        }
      }
      // if( this.promotion.productFreeType === 3)
      // {
      //   if(this.joinPromotion.freeTotalquantity < this.joinPromotion.limitTotalquantity)
      //   {
      //     this.validateRules.freelimitValidateText = 'จำนวนสินค้าจำกัดต้องน้อยกว่าจำนวนของแถมทั้งหมด'
      //     return;
      //   }
      // }
    
      var marketplact_list = this.marketpalce.selectMarketpalce.map((i) => ({
                              ID: this.isedit ? i.uniqueID : 0,
                              channelID: i.channelID,
                              sellerID: i.sellerID.toString(),
                            }));
      if(marketplact_list.length==0){
        this.loading=false;
        this.$swal({ 
          type: "warning",
          text: this.use_language.select_sales_channel,
        });
        return;
      }
      const dataPromo = await this.formatDataPromotion();
      var datenow = new Date();
      var tempStart = new Date(dataPromo.StartDate);
      var tempEnd = new Date(dataPromo.EndDate);
      console.log(dataPromo );
      
      if( dataPromo.id==0   && datenow>tempStart  ){
        this.loading=false;
        this.$swal({ 
          type: "warning",
          text: this.use_language.promo_start_not_past,
        });
        return;
      }
      if(tempEnd<=tempStart){
        this.loading=false;
        this.$swal({ 
          type: "warning",
          text: this.use_language.promo_end_after_start + "!",
        });
        return;
      }
      let productlistsets = [];
      if (!this.promotion.joinProgram) {
        productlistsets = await this.formatProductList(this.productList, 1);
      }
 
    
      
      if(productlistsets.length>0 && productlistsets.filter((i)=> i.Quantity ==0).length>0){
        this.loading=false;
        this.$swal({ 
          type: "warning",
          text: this.use_language.participating_quantity_not_zero,
        });
        return;
      }
      
      let notjoinproductListsets = await this.formatProductList(
        this.notjoinproductList,
        2
      );
      let freeProductlistsets = await this.formatProductList(this.freeProductList, 3);
      if(freeProductlistsets.length==0){
        this.loading=false;
        this.$swal({ 
          type: "warning",
          text: this.use_language.please_select_free_gift + "!",
        });
        return;
      }
      const ProductItem = [
        productlistsets,
        notjoinproductListsets,
        freeProductlistsets,
      ].reduce((acc, curr) => acc.concat(curr), []);
      // if (!this.marketpalce.allData.some(x => x.selectSeller === true)) {
      //   this.$swal({
      //       position: "top",
      //       type: "warning",
      //       text: "กรุณาเลือกช่องทาง",
      //     })
      //   return;
      // }
      if (this.$refs.promotion.validate()) {
        let response = await axios.post(
          shopService_dotnet + "Promotion/add-promotion",
          {
            shopID: this.shopID,
            promotion: dataPromo,
            promotionItems: ProductItem,
            promotionChannels: marketplact_list,
            deletedItemIDList: this.promotion.deleteItemIDlist,
          },
          { headers: this.header_token }
        );
        if (response.data.status) {
          this.loading=false;
          localStorage.removeItem("promotionID");
          this.$router.push("/promotion");
        }
      }else{
        this.loading=false;
      }
    },
      updateFormattedStartDate() {
          this.formattedStartDate = this.formatDate(this.startDatePromotion);
      },
      updateFormattedEndDate() {
          this.formattedEndDate = this.formatDate(this.endDatePromotion); 
      },
    async exportexcel() {
      this.orderMaster.dataExcel = [];
      this.orderMaster.loadingExcel = 0;
      //เรียกใช้Export
      var limits = 50;
      var offsets = 0;
      this.orderMaster.loadingExcel = 1;
      var total = this.orderMaster.total;
      var round = parseInt(total / limits);
      if (limits * round < total) {
        round = round + 1;
      }
      var no = 0;
      const channelName = {
        3: "Shopee",
        4: "Lazada",
        11: "tiktok",
        144: "Woo",
        8: "LineMyShop",
        6: "Shopify",
      };
      for (var i = 1; i <= round; i++) {
        var data = await this.getOrderMasterFreeProductListExcel(limits, offsets);
        for (var j in data) {
          no += 1;
          this.orderMaster.dataExcel.push({
            No: no,
            orderMasterID: this.GenPA(data[j].orderMasterID),
            Date: this.formatDatetime(data[j].paymentDate),
            referenceSourceID: channelName[data[j].referenceSourceID] || null,
            referenceNumber: data[j].referenceNumber.replace("Tiktok-",""),
            totalPrice :  data[j].totalPrice,
            deliveryCost :   data[j].deliveryCost,
            marketplaceSellerName :   data[j].marketplaceSellerName,
            sellerDeliveryDiscount :   data[j].sellerDeliveryDiscount,
            totalPlatformDiscount :   data[j].totalPlatformDiscount,
            totalSellerDiscount :   data[j].totalSellerDiscount,
            orderTotalAmount:  data[j].orderTotalAmount ,
          });
        }
        this.orderMaster.loadingExcel = (this.orderMaster.dataExcel.length * 100) / total;
        if (round < 100) {
          this.orderMaster.loadingExcel = parseInt(this.orderMaster.loadingExcel);
        } else {
          this.orderMaster.loadingExcel = this.orderMaster.loadingExcel.toFixed(1);
        }
        //เพิ่มtake
        offsets = offsets + limits;
      }
      this.orderMaster.loadingExcel = this.orderMaster.dataExcel.length == 0 ? 0 : 100;
      document.getElementById("GetExcelAll").click();
    },
    async getOrderMasterFreeProductListExcel(limits, offsets) {
      try {
        let response = await axios.post(
          shopService_dotnet + "Promotion/get-promotion-ordermaster",
          {
            promotionID: this.PromotionID,
            skip: offsets,
            take: limits,
          },
          { headers: this.header_token }
        );
        if (response.data.status) {
          return response.data.promotionOrderMasters;
        }
      } catch {
        this.$swal({
          toast: true,
          timer: 3000,
          showConfirmButton: false,
          position: "center",
          type: "error",
          title: this.use_language.error_cannot_download,
        });
      }
    },
    async formatDataPromotion() {
      // set data

      let fulldateStart = this.startDatePromotion + " " + this.timeStart + ":00";
      let fulldateEnd = this.endDatePromotion + " " + this.timeEnd + ":00";
      let promotion = {};
      this.isedit == true
        ? (promotion.ID = parseInt(this.PromotionID))
        : (promotion.ID = 0);
      promotion.StartDate = fulldateStart;
      promotion.EndDate = fulldateEnd;
      promotion.Name = this.promotion.name;
      promotion.isUseMultiplier = this.promotion.isUseMultiplier;
      promotion.MinOrderFreeProduct = this.promotion.productFreeOrder;
      promotion.promotionType = this.promotion.promotionType;
      promotion.CreatedBy = parseInt(localStorage.getItem("staff_id"));
      if (this.promotion.promotionType === 1) {
        promotion.MinSpend = this.promotion.amount;
        promotion.MinQuantity = null;
      } else {
        promotion.MinQuantity = this.promotion.quantity;
        promotion.MinSpend = null;
      }
      promotion.IsOverlapped = this.promotion.duplicate;
      if (!this.promotion.duplicate) {
        promotion.priority = this.promotion.priority;
      } else {
        promotion.priority = null;
      }
      promotion.FreePromotionType = this.promotion.productFreeType;
      return promotion;
    },
    async formatProductList(productList, productType) {
      return productList.map((e) => {
        const baseObject = {
          id: this.isedit == true ? e.promotionitemID || 0 : 0,
          ProductMasterItemID: e.id,
          productType: productType,
        };
       
        console.log( e.quantityInput);
        
        if (productType === 1) {
          baseObject.Quantity = Number.isNaN(Number(e.quantityInput)) || e.quantityInput=="" || e.quantityInput==null
            ? null
            : Number(e.quantityInput);
        }
        if (productType === 3) {
          baseObject.Quantity = Number.isNaN(Number(e.quantityInput)) || e.quantityInput==""|| e.quantityInput==null
            ? null
            : Number(e.quantityInput);
          if (this.promotion.productFreeType === 3) {
            baseObject.LimitQuantity = Number.isNaN(Number(e.limitquantityInput))
              ? null
              : Number(e.limitquantityInput);
          }
        }
        return baseObject;
      });
    },
    async formatDataMarketplace(item, photo, channelID) {
      // ยัดรูปเข้าobjectของMarketplace ที่response ออกมาทุกobject
      return item.map((e) => {
        const baseObject = {
          ...e, //เป็นการใช้ spread operator และเพิ่ม photolink เข้าไปด้วยในการคืนค่าของ map
          photoLink: photo,
          channelID: channelID,
        };
        if (baseObject.channelID === 3) {
          baseObject.sellerID = e.shopeeShopId;
          baseObject.name = e.shopeeShopName;
        } else if (baseObject.channelID === 4) {
          baseObject.sellerID = e.lazadaSellerId;
          baseObject.name = e.lazadaShopName;
        } else if (baseObject.channelID === 11) {
          baseObject.sellerID = e.tiktok_shop_id;
          baseObject.name = e.shop_name;
        } else if (baseObject.channelID === 144) {
          baseObject.sellerID = e.id.toString();
          baseObject.name = e.baseUrl;
        } else if (baseObject.channelID === 8) {
          baseObject.sellerID = e.id.toString();
          baseObject.name = e.shopName;
        } else if (baseObject.channelID === 6) {
          baseObject.sellerID = e.id.toString();
          baseObject.name = e.baseUrl;
        } else if (baseObject.channelID === 1437 || baseObject.channelID === 1341) {
          baseObject.sellerID = e.id.toString();
          baseObject.name = e.name;
        }
        return baseObject;
      });
    },
    formatDate(date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
    },
    parseDate(date) { 
       console.log("parseDate ",date);
      if (!date) return null;
      const [day, month, year] = date.split("-");
        
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    async changePage() {
      if (this.pageLength != 1 && this.pageTemp != this.page) {
        this.offsets = this.page * this.limits - this.limits;
        await this.getSelectProduct(
          this.limits,
          this.offsets,
          this.joinPromotion.searchNamePopup,
          this.page
        );
        this.pageTemp = this.page;

        if (this.joinPromotion.productSelect.length > 0) {
          for (var item_1 of this.joinPromotion.productSelect) {
            for (var item_2 of this.joinPromotion.data) {
              if (item_1.id == item_2.id) {
                item_2.selectProduct = true;
                continue;
              }
            }
          }
        }
      }
    },
    async changePageOrderMaster() {
      if (
        this.orderMaster.pageLength != 1 &&
        this.orderMaster.pageTemp != this.orderMaster.page
      ) {
        this.orderMaster.offsets =
          this.orderMaster.page * this.orderMaster.limits - this.orderMaster.limits;
        await this.getOrderMasterFreeProductList(
          this.orderMaster.limits,
          this.orderMaster.offsets,
          this.page,
          null
        );
        this.orderMaster.pageTemp = this.orderMaster.page;
      }
    },
    async setRules() {},
    async clearRules() {
      this.validateRules.promotionNameRules = [];
      this.validateRules.promotionNameValidateText = null;
      this.validateRules.amountRules = [];
      this.validateRules.amountValidateText = null;
      this.validateRules.quantityRules = [];
      this.validateRules.quantityValidateText = null;
      this.validateRules.totalquantityValidateText = null;
      this.validateRules.freelimitValidateText = null;
      this.validateRules.freeMinOrderValidateText = null;
      this.validateRules.freeMinOrderRules = [];
      this.validateRules.freeMinquantityRules = [];
      this.validateRules.freeMinquantityText = null;
      this.validateRules.priorityRules = [];
      this.validateRules.priorityValidateText = null;
    },
    OpenPhoto(Photo) {
      this.ShowPhotoLink = Photo;
      this.ShowPhoto = true;
    },
    Opentap(PhotoLink) {
      window.open(PhotoLink);
    },
    CheckDateTime(index, startDate, endDate) {
      if (startDate != null && endDate != null) {
        var PstartDate = startDate;
        var PendDate = endDate;
        if (new Date(startDate) > new Date(endDate)) {
          PstartDate = endDate;
          PendDate = startDate;
        }
        startDate = PstartDate;
        endDate = PendDate;
      }
      if (index == 0) {
        this.startDate = startDate;
        this.endDate = endDate;
        this.dateStart = this.formatDate(startDate);
        this.dateEnd = this.formatDate(endDate);
      }
    },
    async toBack(path) {
      localStorage.removeItem("promotionID");
      this.$router.push("/" + path);
    },
    detail_page(token) {
      var redirectPath = `${window.location.origin}/order-detail?id=${token}`;
      window.open(redirectPath, "_blank");
    },
    formatLocalDate(date) {
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hours = date.getHours();
      let minutes = date.getMinutes();

      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;

      return `${year}-${month}-${day}/${hours}:${minutes}`;
    },
    formateDate(date) {
    console.log(date);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours().toString().padStart(2, "0");
      var minutes = date.getMinutes().toString().padStart(2, "0");
       var second = date.getSeconds().toString().padStart(2, "0");
      const dateformat = `${day}/${month}/${year} ${hours}:${minutes}:${second}`;
      return dateformat;
    },
  },
};
</script>

<style></style>
